<template>
  <div>
    <b-tabs
      pills
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Teklif Bilgileri
        </template>
        <b-card>
          <b-row>
            <b-col
              cols="12"
              md="8"
            >
              <purchase-offer-title />
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <purchase-offer-onumber />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <purchase-offer-sdate />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <purchase-offer-edate />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <purchase-offer-content />
            </b-col>
            <!--            <b-col-->
            <!--              cols="12"-->
            <!--              md="6"-->
            <!--            >-->
            <!--              <purchase-offer-amount />-->
            <!--            </b-col>-->
            <!--            <b-col-->
            <!--              cols="12"-->
            <!--              md="6"-->
            <!--            >-->
            <!--              <purchase-offer-price />-->
            <!--            </b-col>-->
          </b-row>
        </b-card>
      </b-tab>
      <b-tab :disabled="!itemData.id">
        <template #title>
          <feather-icon icon="InfoIcon" />
          Teklif Ürünleri
        </template>
        <purchase-offer-stocks v-if="itemData.id" />
      </b-tab>

    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import PurchaseOfferTitle from '@/views/Admin/Purchase_offers/Elements/TitleCard.vue'
import PurchaseOfferOnumber from '@/views/Admin/Purchase_offers/Elements/OnumberCard.vue'
import PurchaseOfferSdate from '@/views/Admin/Purchase_offers/Elements/SdateCard.vue'
import PurchaseOfferEdate from '@/views/Admin/Purchase_offers/Elements/EdateCard.vue'
import PurchaseOfferContent from '@/views/Admin/Purchase_offers/Elements/ContentCard.vue'
// import PurchaseOfferAmount from '@/views/Admin/Purchase_offers/Elements/AmountCard.vue'
// import PurchaseOfferPrice from '@/views/Admin/Purchase_offers/Elements/PriceCard.vue'
import PurchaseOfferStocks from '@/views/Admin/Purchase_offers/Components/PurchaseStocks.vue'

export default {
  name: 'PurchaseOffersItemForm',
  components: {
    PurchaseOfferStocks,
    // PurchaseOfferPrice,
    // PurchaseOfferAmount,
    PurchaseOfferContent,
    PurchaseOfferEdate,
    PurchaseOfferSdate,
    PurchaseOfferOnumber,
    PurchaseOfferTitle,
    BCard,
    BRow,
    BCol,
    BTabs,
    BTab,
  },
  computed: {
    itemData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
}
</script>
